import React, { useEffect, useState } from 'react'
import Button from '../../../../utils/components/Button/Button'
import File from '../../../../utils/components/File/File'
import Input from '../../../../utils/components/Input/Input'
import useModal from '../../../../utils/hooks/useModal'
import { usePlaces } from '../../../../utils/hooks/usePlaces'
import Calendar from 'react-calendar';
import style from "./CreateJob.module.css"
const CreateJob = ({ formik, job, isEdit = false }) => {
  const { countries, states, cities } = usePlaces(formik.values.country, formik.values.state)
  const [srcImg, setSrcImg] = useState(null)
  const [srcOfert, setSrcOfert] = useState(null)
  const [refDate, isShowDate, setIsShowDate] = useModal(false)
  useEffect(() => {
    if (job?._id) {
      setSrcImg(job.picture && job.picture.url && job.picture.url.origin)
      setSrcOfert(job.offerpdf && job.offerpdf.url && job.offerpdf.url.origin)
    }

    return () => {

    }
  }, [job])


  return (
    <div>
      <div className={style.form_container}>
        <label className={style.form_img}>
          {srcImg && <img className={style.form_img} src={srcImg} alt="" />}
          <input type="file"
            onChange={(e) => {

              if (e.target.files[0] && e.target.files[0].type.includes('image')) {
                formik.setFieldValue("picture", e.target.files[0])


                setSrcImg(URL.createObjectURL(e.target.files[0]))
              }
            }}
          />
        </label>

      </div>

      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="name"
          type="text"
          placeholder={'Nombre'}
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.name}
        />

      </div>
      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="mimSalary"
          type="number"
          max={formik.values.maxSalar}
          placeholder={'Salario mínimo'}
          value={formik.values.mimSalary}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.mimSalary}
        />
        <Input
          classNameInput={style.input_form}
          name="maxSalary"
          type="number"
          placeholder={'Salario máximo'}
          min={formik.values.mimSalary}
          value={formik.values.maxSalary}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.maxSalary}
        />
      </div>
      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="knowledgeArea"
          type="text"
          placeholder={'Area de conocimiento'}
          value={formik.values.knowledgeArea}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.knowledgeArea}
        />

        <Input
          classNameInput={style.input_form}
          name="description"
          type="text"
          placeholder={'description'}
          value={formik.values.description}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.description}
        />
      </div>
      <div className={style.form_container} ref={refDate}>
        <Input
          classNameInput={style.input_form}
          name="limitDate"
          type="text"
          readOnly
          placeholder={'Fecha limite'}
          value={!isNaN(new Date(formik.values.limitDate).getDate()) ? new Date(formik.values.limitDate).toLocaleDateString() : new Date().toLocaleDateString()}

          error={formik.errors.limitDate}
          onClick={() => setIsShowDate(true)}
        />
        {
          isShowDate && (
            <div className='calendar-register'>
              <Calendar
                onChange={(dateTime) => {
                  formik.setFieldValue('limitDate', new Date(dateTime));
                  setIsShowDate(false)
                }}
              />
            </div>
          )
        }
        <File
          name="offerpdf"
          text={(formik.values.offerpdf || srcOfert)? "Archivo cargado" : "Carge la oferta detallada"}
          onChange={(event) => formik.setFieldValue("offerpdf", event.target.files[0])}
        />
      </div>
      <div className={style.form_container}>
        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="country"
            value={formik.values.country}
            onChange={formik.handleChange}
          >
            <option value="">País</option>
            {countries.map((country) => (
              <option key={country.countryID} value={country.countryName}>
                {country.countryName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.country}</div>
        </div>

        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="state"
            value={formik.values.state}
            onChange={formik.handleChange}
          >

            <option value="">Departamento</option>
            {states.map((state) => (
              <option key={state.stateID} value={state.stateName}>
                {state.stateName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.state}</div>

        </div>

        <div className='input-select-style-container'>
          <select
            className={`input-select-style ${style.input_select}`}
            name="city" value={formik.values.city}
            onChange={formik.handleChange}
          >
            <option value="">Ciudad</option>
            {cities.map((city) => (
              <option key={city.cityID} value={city.cityName}>
                {city.cityName}
              </option>
            )
            )}
          </select>
          <div className={`text-error-input`}>{formik.errors.city}</div>

        </div>
      </div>
      <div className={style.form_container}>


        <Input
          classNameInput={style.input_form}
          name="quantityVacancies"
          type="text"
          placeholder={'Vacantes'}
          value={formik.values.quantityVacancies}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.quantityVacancies}
        />

        <Input
          classNameInput={style.input_form}
          name="company"
          type="text"
          placeholder={'Compañía'}
          value={formik.values.company}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.company}
        />
      </div>
      <div className={style.form_container}>
        <Input
          classNameInput={style.input_form}
          name="email"
          type="email"
          placeholder={'Correo'}
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.email}
        />
        <Input
          classNameInput={style.input_form}
          name="contact"
          type="text"
          placeholder={'Contacto'}
          value={formik.values.contact}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.errors.contact}
        />
      </div>
      <div className={style.form_container}>

        <Button
          type='submit'
          onClick={formik.handleSubmit}
          text='Crear'
        />
      </div>







    </div>
  )
}

export default CreateJob